import { combineReducers } from "redux";

import app from "./app";
import customer from "./customer";
import division from "./division";
import error from "./error";
import feedback from "./feedback";
import loading from "./loading";
import navigation from "./navigation";
import network from "./network";
import organization from "./organization";
import questionnaires from "./questionnaires";
import response from "./response";
import root from "./root";
import survey from "./survey";
import taker from "./taker";

const appReducer = combineReducers({
  app,
  customer,
  division,
  error,
  feedback,
  loading,
  navigation,
  network,
  organization,
  questionnaires,
  response,
  survey,
  taker,
});

const rootReducer = root(appReducer);

export default rootReducer;
